/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateOrderInfo200ResponseResultsInner
 */
export interface BulkUpdateOrderInfo200ResponseResultsInner {
    /**
     * 注文番号
     * @type {string}
     * @memberof BulkUpdateOrderInfo200ResponseResultsInner
     */
    orderNo: string;
    /**
     * 更新成功フラグ
     * @type {boolean}
     * @memberof BulkUpdateOrderInfo200ResponseResultsInner
     */
    success: boolean;
    /**
     * エラーメッセージ（失敗時のみ）
     * @type {string}
     * @memberof BulkUpdateOrderInfo200ResponseResultsInner
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the BulkUpdateOrderInfo200ResponseResultsInner interface.
 */
export function instanceOfBulkUpdateOrderInfo200ResponseResultsInner(value: object): value is BulkUpdateOrderInfo200ResponseResultsInner {
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function BulkUpdateOrderInfo200ResponseResultsInnerFromJSON(json: any): BulkUpdateOrderInfo200ResponseResultsInner {
    return BulkUpdateOrderInfo200ResponseResultsInnerFromJSONTyped(json, false);
}

export function BulkUpdateOrderInfo200ResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateOrderInfo200ResponseResultsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'orderNo': json['order_no'],
        'success': json['success'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
    };
}

export function BulkUpdateOrderInfo200ResponseResultsInnerToJSON(json: any): BulkUpdateOrderInfo200ResponseResultsInner {
    return BulkUpdateOrderInfo200ResponseResultsInnerToJSONTyped(json, false);
}

export function BulkUpdateOrderInfo200ResponseResultsInnerToJSONTyped(value?: BulkUpdateOrderInfo200ResponseResultsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order_no': value['orderNo'],
        'success': value['success'],
        'error_message': value['errorMessage'],
    };
}

